import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as person from '../person'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: person.RESOURCE.payload.dimension.partialId,
      partialId: person.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Last Name',
    isOptional: true,
    name: 'Last Name',
    partialId: PartialId.Standard.create('last'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
